import { useLazyQuery } from "@apollo/client";
import { SmallTitle } from "components/Common/Typography/Titles";
import { BooleanExtractor } from "gql/boolean.gql";
import React, { useEffect, useState } from "react";
import starsicon from "../../images/stars.svg";
import { useDispatch } from "react-redux";
import { readToken } from "services/localStorage.service";
import {
  addCandidateExcludeCompanyList,
  addCandidateWorkCompanyList,
  addExcludeLocation,
  addJobTitle,
  addKeyword,
  addLocation,
  addMaxExp,
  addMinExp,
  addSkill,
} from "store/slices/searcSlice";
import { Spin } from "antd";
import FiltersAISearchInput from "components/Common/Input/FiltersAISearchInput";

const AISearchAndSet: React.FC = () => {
  const dispatch = useDispatch();
  const [AIQuery, setAIQuery] = useState("");

  // Lazy query for search config generator
  const [searchConfigGenerator, { data: searchDetails, loading }] = useLazyQuery(BooleanExtractor);

  // Handle button click to trigger search
  const handleSearchClick = () => {
    if (AIQuery.trim()) {
      searchConfigGenerator({ variables: { jobDescription: AIQuery, token: readToken() } });
    }
  };

  // UseEffect to dispatch search details to redux store once query result is available
  useEffect(() => {
    if (searchDetails) {

      const { searchConfigGenerator } = searchDetails;

      searchConfigGenerator?.suggestedJobTitles?.forEach((title: string) =>
        dispatch(addJobTitle(title))
      );
      searchConfigGenerator?.keywords?.forEach((keyword: string) => dispatch(addKeyword(keyword)));
      searchConfigGenerator?.skills?.forEach((skill: string) => dispatch(addSkill(skill)));
      dispatch(
        addCandidateWorkCompanyList(
          searchConfigGenerator?.companies?.map((company: string) => ({ name: company }))
        )
      );
      dispatch(
        addCandidateExcludeCompanyList(
          searchConfigGenerator?.companiesExclude?.map((company: string) => (company))
        )
      );
      if (searchConfigGenerator?.locations) dispatch(addLocation(searchConfigGenerator?.locations));
      if (searchConfigGenerator?.locationsExclude)
        dispatch(addExcludeLocation(searchConfigGenerator?.locationsExclude));

      // dispatch(
      //   addWorkExperience({
      //     jobTitle: searchConfigGenerator?.jobTitles[0],
      //     minWorkExp: searchConfigGenerator?.experienceMin,
      //     maxWorkExp: searchConfigGenerator?.experienceMax,
      //   })
      // );
      dispatch(addJobTitle(searchConfigGenerator?.jobTitles));
      dispatch(addMinExp(searchConfigGenerator?.experienceMin));
      dispatch(
        addMaxExp(
          searchConfigGenerator?.experienceMax
            ? searchConfigGenerator?.experienceMax
            : 60
        )
      );

      setAIQuery("");
    }
  }, [searchDetails]);

  return (
    <>
      <div className="mt-1.5 relative">
        <FiltersAISearchInput
          AIQuery={AIQuery}
          setAIQuery={setAIQuery}
          loading={loading}
          onSearchQueryClick={handleSearchClick}
        />
      </div>
    </>
  );
};

export default AISearchAndSet;
